import type { Dispatch, SetStateAction } from "react";
import { useQuoteCopy } from "../i18n/QuoteCopyContext";
import type { DepartmentConfig, FormState } from "../types";
import type { ExtractFillMap } from "../extractFill";
import type { Errors } from "../validation";
import { AdditionalServices } from "./AdditionalServices";
import { WizardPage } from "./WizardPage";

interface Props {
  form: FormState;
  setForm: Dispatch<SetStateAction<FormState>>;
  errors: Errors;
  hasErrors: boolean;
  extractFill?: ExtractFillMap;
  config: DepartmentConfig;
  onBack: () => void;
  onContinue: () => void;
}

export function AdditionalServicesStep({
  form,
  setForm,
  errors,
  hasErrors,
  extractFill,
  config,
  onBack,
  onContinue,
}: Props) {
  const copy = useQuoteCopy();
  return (
    <WizardPage title={copy.t("page.services")} hasErrors={hasErrors} onBack={onBack} onContinue={onContinue}>
      <section className="nv-section">
        <h3 className="nv-section-title">{copy.t("page.services")}</h3>
        <AdditionalServices
          form={form}
          setForm={setForm}
          errors={errors}
          extractFill={extractFill}
          config={config}
        />
      </section>
    </WizardPage>
  );
}
